export default {
    name: 'DGOCol',
    componentName: 'DGOCol',
    props: {
        baseClass: {
            type: String,
            default: 'dgo-col'
        },
        tag: {
            type: String,
            default: 'div',
        },
        size: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ((Number.isInteger(Number(value[item])) && Number(value[item]) > 0 && Number(value[item])  < 25 )
                        || ['auto', 'none'].includes(value[item])) : total, true),
        },
        justify: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['self-start', 'self-end', 'normal'].includes(value[item]) : total, true),
        },
        align: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['self-start', 'self-end', 'center', 'stretch'].includes(value[item]) : total, true),
        },
        order: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && (Number.isInteger(Number(value[item])) && Number(value[item]) > 0 && Number(value[item])) < 25
                    : total, true),
        },
        offset: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && (Number.isInteger(Number(value[item])) && Number(value[item]) > 0 && Number(value[item])) < 25
                    : total, true),
        },
    },
    computed: {
        gutter() {
            let parent = this.$parent;
            while (parent && parent.$options.componentName !== 'DGOContainer') { parent = parent.$parent; }
            return parent ? Number(parent.gutter) : 0;
        },
        sizeClass() {
            if (Object.keys(this.size).length) {
                return Object.keys(this.size).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--${this.size[item]}`
                        : `${this.baseClass}--${item}-${this.size[item]}`)
            }

            return [];
        },
        justifyClass() {
            if (Object.keys(this.justify).length) {
                return Object.keys(this.justify).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--justify-${this.justify[item]}`
                        : `${this.baseClass}--${item}-justify-${this.justify[item]}`)
            }

            return [];
        },
        alignClass() {
            if (Object.keys(this.align).length) {
                return Object.keys(this.align).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--align-${this.align[item]}`
                        : `${this.baseClass}--${item}-align-${this.align[item]}`)
            }

            return [];
        },
        orderClass() {
            if (Object.keys(this.order).length) {
                return Object.keys(this.order).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--order-${this.order[item]}`
                        : `${this.baseClass}--${item}-order-${this.order[item]}`)
            }

            return [];
        },
        offsetClass() {
            if (Object.keys(this.offset).length) {
                return Object.keys(this.offset).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--offset-${this.offset[item]}`
                        : `${this.baseClass}--${item}-offset-${this.offset[item]}`)
            }

            return [];
        },
    },
    data() {
        return {};
    }
}
